import { createFileRoute, redirect } from '@tanstack/react-router'
import { getCurrentUser } from '@/api/auth.api'
import { APP_NAME } from '@/lib/utils'
import SignIn2 from '@/features/auth/sign-in/sign-in-2'
import { initialFilters, intialSorting } from '@/features/commands/data/data'

export const Route = createFileRoute('/(auth)/sign-in-2')({
  component: SignIn2,
  head: () => ({
    meta: [
      {
        title: `${APP_NAME} | Se Connecter`,
      },
    ],
  }),
  beforeLoad: async () => {
    const res = await getCurrentUser().catch(() => null)
    if (res?.id) {
      throw redirect({
        to: '/commands',
        search: { sorting: intialSorting, filter: initialFilters },
      })
    }
  },
})
